import script from "./ContactAboutSettings.vue?vue&type=script&setup=true&lang=js"
export * from "./ContactAboutSettings.vue?vue&type=script&setup=true&lang=js"

import "./ContactAboutSettings.vue?vue&type=style&index=0&id=54e19bed&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54e19bed"]])

export default __exports__